import { PaymentSecuritiesService } from '../services/payment-securities.service';
import { BarCodeValidate } from './../../../shared/bar-code-validate';
import { PaymentSecuritiesEventType } from './../payment-securities.event.type';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import * as moment from 'moment';
import { Payment } from '../models/payment';
import { EventTypes } from '../../../shared/EventTypes';
import { DashboardService } from '../../dashboard/dashboard.service';
import { Limit } from '../../limits/models/limits';
import { PaymentErrorType } from '../models/payment-error-type';
import { ModalConfirmService } from '../../../shared/modal-confirm/modal-confirm.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ModalConfirmComponent } from '../../../shared/modal-confirm/modal-confirm.component';
import { SharedService } from '../../../shared/shared.service';

@Component({
	selector: 'app-payment-data',
	templateUrl: './payment-data.component.html',
	styleUrls: ['./payment-data.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PaymentDataComponent implements OnInit, OnDestroy {
	@Input() flow: string;
	@Input() submited = false;
	@Input() paymentData: Payment;
	@Output() formInvalid: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	public nominalValue;
	public biggerValueError = false;

	public form: FormGroup;
	private view = '[data-component="payment-data"]';
	private today: number = Date.now();
	private viewHeight = 0;
	private lastChackedDate?: Date;
	private hasCheckedToday = false;
	public isDateInput = true;
	dataLimits: Array<Limit>;
	active = false;
	scheduleError = false;
	barCodeError = false;
	barCodeErrorConvenio = false;
	barCode;
	barCodeOld;
	public scheduleSpan = false;
	dataOfSecuritie = false;
	isSecuritie: boolean;
	securitieLimitDateVerify = false;
	message: string;
	consultReturn: Payment;
	consultReturnAgreement: Payment;
	consultError = false;

	securitieSend = false;
	isDateChange = false;

	anyValue = false;
	minTypeValue = false;
	minMaxTypeValue = false;
	totalTypeValue = false;
	parcialPayment = true;
	isAgreement = false;

	private minimunDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
	data: any;
	dialogRef: MatDialogRef<ModalConfirmComponent>

	constructor(
		private formBuilder: FormBuilder,
		private paymentService: PaymentSecuritiesService,
		private dashboardService: DashboardService,
		private modalConfirmService: ModalConfirmService,
		private sharedService: SharedService,
		private dialog: MatDialog,
	) {
		this.scheduleSpan = this.paymentService.scheduleSpan;

		this.form = formBuilder.group({
			barCode: [null, Validators.required],
			dueDate: [null, Validators.required],
			dueDateInput: [null],
			paymentDate: ['today', Validators.required],
			scheduleDate: [null],
			value: [null, Validators.required],
			taxValue: [null],
			securitieRebateValue: [null],
			fineValue: [null],
			discountValue: [null],
			minValue: [null],
			maxValue: [null]
		});
	}

	ngOnInit() {
		AppEventDispatcher.listen(PaymentSecuritiesEventType.STEPS.PAYMENT_DATA, () => {
			this.active = true;
			this.setForm.emit(this.form);
			this.show();
		});

		AppEventDispatcher.listen(PaymentSecuritiesEventType.SEND.PAYMENT_DATA_SEND, () => {
			this.send();
		});

		this.quickPaymentDashboard();

	}

	quickPaymentDashboard() {
		this.dashboardService.currentMessage.subscribe((message) => {
			this.message = message;

			if (this.message.length) {
				this.form.controls.barCode.setValue(this.message);

				this.checkBarCode();
			}

		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(PaymentSecuritiesEventType.STEPS.PAYMENT_DATA);
		AppEventDispatcher.removeListener(PaymentSecuritiesEventType.SEND.PAYMENT_DATA_SEND);
		this.dashboardService.changeMessage('');
	}

	dateFormat(e) {
		let newDate = e.target.value.toString();
		newDate = newDate.replace(/\D/g, '');
		newDate = newDate.replace(/(\d{2})(\d)/, '$1/$2');
		newDate = newDate.replace(/(\d{2})(\d)/, '$1/$2');
		this.scheduleError = true;

		if (newDate.length === 10) {
			this.scheduleError = false;
			const data = moment(newDate, 'DD/MM/YYYY');

			if (data.isValid() && data.isAfter(moment())){
				e.target.value = newDate;
				this.form.get('scheduleDate').setValue(data.toDate());
				this.form.get('scheduleDate').setErrors(null);
				this.checkDateOption('schedule');
				return;
			}

			e.target.value = newDate;
			this.form.get('scheduleDate').setErrors({ 'required': true });
			this.scheduleError = true;
		}else {
			e.target.value = newDate;
		}
	}

	dueDateFormat(e) {
		let newDueDate = e.target.value.toString();
		newDueDate = newDueDate.replace(/\D/g, '');
		newDueDate = newDueDate.replace(/(\d{2})(\d)/, '$1/$2');
		newDueDate = newDueDate.replace(/(\d{2})(\d)/, '$1/$2');
		if (newDueDate.length === 10) {
			const arrDueDate = newDueDate.split('/');
			const finalDueDate = arrDueDate[1] + '/' + arrDueDate[0] + '/' + arrDueDate[2];
			const novaDueData = new Date(finalDueDate);
			if (!isNaN(novaDueData.getTime())) {
				this.form.get('dueDate').setValue(new Date(finalDueDate));
				this.form.get('dueDate').setErrors(null);
			} else {
				e.target.value = newDueDate;
				this.form.get('dueDate').setErrors({ 'required': true });
			}
		}else {
			e.target.value = newDueDate;
		}
	}

	validateZero() {
		if (!this.parcialPayment) {
			if ($('.currency-field').val() === '0,00' || $('.currency-field').val() === '0,') {
				$('.currency-field').val('');
			}
		}
	}

	barCodeMask(event) {
		if (event.target.value.length <= 55) {
			// remove all mask characters (keep only numeric)
			let newVal = event.target.value.replace(/\D/g, '');

			// don't show braces for empty value
			if (newVal.length === 0) {
				newVal = '';
			} else if (newVal.length <= 5) {
				newVal = newVal.replace(/^(\d{0,5})/, '$1');
			} else if (newVal.length <= 10) {
				newVal = newVal.replace(/^(\d{0,5})(\d{0,5})/, '$1.$2');
			} else if (newVal.length <= 15) {
				newVal = newVal.replace(/^(\d{0,5})(\d{0,5})(\d{0,5})/, '$1.$2 $3');
			} else if (newVal.length <= 21) {
				newVal = newVal.replace(
					/^(\d{0,5})(\d{0,5})(\d{0,5})(\d{0,6})/,
					'$1.$2 $3.$4'
				);
			} else if (newVal.length <= 26) {
				newVal = newVal.replace(
					/^(\d{0,5})(\d{0,5})(\d{0,5})(\d{0,6})(\d{0,5})/,
					'$1.$2 $3.$4 $5'
				);
			} else if (newVal.length <= 32) {
				newVal = newVal.replace(
					/^(\d{0,5})(\d{0,5})(\d{0,5})(\d{0,6})(\d{0,5})(\d{0,6})/,
					'$1.$2 $3.$4 $5.$6'
				);
			} else if (newVal.length <= 33) {
				newVal = newVal.replace(
					/^(\d{0,5})(\d{0,5})(\d{0,5})(\d{0,6})(\d{0,5})(\d{0,6})(\d{0,1})/,
					'$1.$2 $3.$4 $5.$6 $7'
				);
			} else if (newVal.length <= 47) {
				newVal = newVal.replace(
					/^(\d{0,5})(\d{0,5})(\d{0,5})(\d{0,6})(\d{0,5})(\d{0,6})(\d{0,1})(\d{0,14})/,
					'$1.$2 $3.$4 $5.$6 $7 $8'
				);
			} else {
				newVal = newVal.replace(
					/^(\d{0,11})(\d{0,1})(\d{0,11})(\d{0,1})(\d{0,11})(\d{0,1})(\d{0,11})(\d{0,1})/,
					'$1-$2 $3-$4 $5-$6 $7-$8'
				);
			}

			// set the new value
			this.barCodeOld = this.barCode = newVal;
		} else {
			this.barCode = this.barCodeOld;
		}
	}

	maskBarCode(event) {
		const p = event.target.value;
		const firstStringSecuritie = p.substring(0, 1);

		if ( firstStringSecuritie !== '8' ) {
			let a = p.replace(/\D/g, '').substring(0, /^8/.test(p) ? 48 : 47);
			a = a
				.replace(
					/(\d{0,5})(\d{0,5})(\d{0,5})(\d{0,6})(\d{0,5})(\d{0,6})(\d{0,1})(\d{0,})/gi,
					'$1.$2.$3.$4.$5.$6.$7.$8'
				)
				.replace(/\.*$/, '')
				.substring(0, 54);

			this.form.controls.barCode.setValue(a);
		} else {
			let a = p.replace(/\D/g, '');
			a = a
				.replace(
					/(\d{0,11})(\d{0,1})(\d{0,11})(\d{0,1})(\d{0,11})(\d{0,1})(\d{0,11})(\d{0,1})(\d{0,})/gi,
					'$1-$2 $3-$4 $5-$6 $7-$8 $9'
				)
				.replace(/( |-)*$/, '')
				.substring(0, 55);

			this.form.controls.barCode.setValue(a);
		}

		this.dataOfSecuritie = false;
		this.consultError = false;
	}

	show() {
		this.checkDateOption();

		const interval = setInterval(() => {
			if ($(this.view).length > 0) {
				// Seta o código vindo do widget da daashboard
				if (DashboardService.dashboardBarcode) {
					this.form.controls.barCode.setValue(
						DashboardService.dashboardBarcode
					);

					DashboardService.dashboardBarcode = '';
				}

				const containerHeight = this.getStepHeight() - 72;

				this.viewHeight = containerHeight;

				TweenMax.to('.steps-container', 0.8, {
					height: containerHeight,
					ease: Quint.easeOut
				});
				TweenMax.to(this.view, 0.8, {
					delay: 0.4,
					left: 0,
					ease: Quint.easeOut
				});
				TweenMax.to('.buttons', 0.8, {
					delay: 0.8,
					bottom: 0,
					ease: Quint.easeOut
				});

				if ($('.currency-field').val() === '0,00' || $('.currency-field').val() === '0,') {
					$('.currency-field').val('');
				}

				$(this.view)
					.find('input')
					.on('keyup focusout', () => {
						this.updateHeight();
					});

				clearInterval(interval);
			}
		}, 10);
	}

	updateHeight() {
		const interval = setInterval(() => {
			const containerHeight = this.getStepHeight();
			TweenMax.to('.steps-container', 0.8, {
				height: containerHeight,
				ease: Quint.easeOut
			});
			clearInterval(interval);
		}, 10);
	}

	hide() {
		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(
				PaymentSecuritiesEventType.STEPS.CONFIRM_PAYMENT,
				{ show: true, securitieCip: this.isSecuritie, securitieAgreement: this.isAgreement }
			);

			TweenMax.to(this.view, 0.8, {
				delay: 0.4,
				left: '-100%',
				ease: Quint.easeOut,
				onComplete: () => {
					this.active = false;
				}
			});
		});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	checkDateOption(type = 'today') {
		this.paymentData.dateType = type;
		const paymenType = this.paymentData.codeBarCip ? "BOLETO" : "CONVENIO";
		if (type === 'schedule') {
			this.scheduleSpan = true;
			this.paymentService.scheduleSpan = true;

			let hasThisDateChecked = false;
			
			if(this.lastChackedDate && this.form.controls.scheduleDate.value){
				hasThisDateChecked = this.lastChackedDate.getTime() === this.form.controls.scheduleDate.value.getTime();
			}

			if (moment().isBefore(this.form.controls.scheduleDate.value) && !hasThisDateChecked) {
				this.sharedService.getDateBlockValidation(paymenType, this.form.controls.scheduleDate.value).subscribe(
					(data) => {
						if (data.Retorno.Aviso) {
							this.modalConfirmService.openAlertModal(data.Retorno.Titulo, '', data.Retorno.Mensagem, 'Entendi', true);
						};
						this.lastChackedDate = this.form.controls.scheduleDate.value;
						return;
					},
				);
			}

			this.updateHeight();
			AppEventDispatcher.dispatch(PaymentSecuritiesEventType.MODAL.TRUE_MODAL, {
				data: false
			});

			this.form.controls.scheduleDate.setValidators(Validators.required);
			this.form.controls.scheduleDate.updateValueAndValidity();

			if (moment().isAfter(this.form.controls.scheduleDate.value)) {
				this.scheduleError = true;
			} else {
				this.scheduleError = false;
			}

			this.form.controls.paymentDate.setValue('schedule');
			this.isDateChange = true;
		} else {
			this.scheduleSpan = false;
			this.paymentService.scheduleSpan = false;
			AppEventDispatcher.dispatch(PaymentSecuritiesEventType.MODAL.TRUE_MODAL, {
				data: true
			});
			this.form.controls.scheduleDate.clearValidators();
			this.form.controls.scheduleDate.setValue('');
			this.updateHeight();
			this.isDateChange = true;

			if(!this.hasCheckedToday && typeof this.paymentData.codeBarCip === 'boolean'){
				this.sharedService.getDateBlockValidation(paymenType, null).subscribe(
					(data) => {
						if (data.Retorno.Aviso) {
							this.modalConfirmService.openAlertModal(data.Retorno.Titulo, '', data.Retorno.Mensagem, 'Entendi', true);
						};
						this.hasCheckedToday = true;
						return;
					},
				);
			}
		}
	}

	clearError() {
		this.barCodeError = false;
	}

	checkBarCode() {
		const barcode = this.form.controls.barCode.value ? this.form.controls.barCode.value.length : 0;

		if ( barcode >= 51) {
			if (!this.dataOfSecuritie) {
				this.barCodeError = false;

				// removido para permitir apenas linha digitável, se depois puder cod de barras, colocar de volta
				// if (barcode === 51 ) {
				// 	this.consultCip();
				// }
					this.validationSecuritie();

			}
		} else {
			this.barCodeErrorConvenio = false;
			this.barCodeError = true;
			this.form.controls.barCode.setErrors({'incorrect': true});
		}
	}

	buildAgreementFields() {
		this.form.controls.value.setValue(this.consultReturnAgreement.value);

		this.form.controls.dueDate.clearValidators();
		this.form.controls.dueDate.updateValueAndValidity();

		this.dataOfSecuritie = true;
		this.updateHeight();
	}

	buildCipFields() {
		this.form.controls.dueDate.clearValidators();
		this.form.controls.dueDate.updateValueAndValidity();

		this.anyValue = this.consultReturn.anyValue;
		this.minTypeValue = this.consultReturn.minTypeValue;
		this.minMaxTypeValue = this.consultReturn.minMaxTypeValue;
		this.totalTypeValue = this.consultReturn.totalTypeValue;
		this.parcialPayment = this.consultReturn.parcialPayment;

		this.form.controls.dueDateInput.setValue(
			moment(this.consultReturn.dueDateInput).format('DD/MM/YYYY')
		);

		this.form.controls.minValue.setValue(this.consultReturn.minValue);

		this.form.controls.maxValue.setValue(this.consultReturn.maxValue);

		if (this.minTypeValue) {
			this.form.controls.value.setValue(this.consultReturn.minValue);
		} else {
			this.form.controls.value.setValue(this.consultReturn.value);
		}
		this.validateMinMaxValue();

		this.isDateInput = false;
		this.dataOfSecuritie = true;
		this.isSecuritie = true;
		this.updateHeight();
	}

	validationSecuritie() {

		const BCV = new BarCodeValidate();

		BCV.boleto(this.form.controls.barCode.value, (boletoError, isBoleto) => {
			BCV.convenio(this.form.controls.barCode.value, (convenioError, isConvenio) => {
				if (!isConvenio && isBoleto) {
					this.isAgreement = false;
					this.consultCip();
				} else if (isConvenio) {
					this.consultAgreement();
				} else {
					this.isAgreement = false;
					this.isDateInput = true;
					this.barCodeErrorConvenio = false;
					this.barCodeError = true;
					this.form.controls.barCode.setErrors({'incorrect': true});
				}
				this.paymentData.codeBarCip = !isConvenio && isBoleto;
				this.checkDateOption()
			});
		});
	}

	consultAgreement() {
		this.preload(true);

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		let dataForConsult;

		if (this.scheduleSpan) {
			dataForConsult = this.form.controls.scheduleDate.value;
		} else {
			dataForConsult = this.form.controls.paymentDate.value;
		}

		this.paymentService.consultPaymentAgreement(this.form.controls.barCode.value, dataForConsult).subscribe(
			data => {
				this.consultReturnAgreement = data;

				this.buildAgreementFields();

				this.clearPreload(time, timeLoader);

				this.isDateChange = false;

				this.isDateInput = true;

				this.isAgreement = true;
			},
			error => {
				this.clearPreload(time, timeLoader);

				this.updateHeight();

				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {
					msg: error.error.Mensagem
				});
			}
		);
	}

	sendAgreementSecuritie() {
		this.paymentData.barCode = this.form.controls.barCode.value.replace(/\D/g, '');

		this.paymentData.value = this.form.controls.value.value;

		if (this.isDateInput) {
			this.paymentData.dueDate = this.form.controls.dueDate.value;
		} else {
			const from = this.form.controls.dueDateInput.value.split('/');
			const f = new Date(from[2], from[1] - 1, from[0]);
			this.paymentData.dueDate = f;
		}

		if (this.form.controls.paymentDate.value === 'today') {
			this.paymentData.date = new Date();
			this.paymentData.dateType = 'today';
			this.paymentData.dateLabel = moment(new Date()).format('DD/MM/YYYY');
		} else {
			this.paymentData.dateType = 'schedule';
			this.paymentData.date = this.form.controls.scheduleDate.value;
			this.paymentData.dateLabel = moment(
				this.form.controls.scheduleDate.value
			).format('DD/MM/YYYY');
		}

		this.paymentData.paymentType = 'Convenio';

		this.paymentData.paymentNameAgreement = this.consultReturnAgreement.paymentNameAgreement;

		this.preload(true);

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		if (!this.barCodeError) {

			this.paymentService.sendPaymentAgreement(this.paymentData).subscribe(data => {

					if (data.Retorno.DadosEntrada.DataAgendamento) {
						this.paymentData.dateLabel = data.Retorno.DadosEntrada.DataAgendamento;
					} else {
						this.paymentData.dateLabel = data.Retorno.DadosEntrada.DataEmissao;
					}

					this.paymentData.paymentId = data.Retorno.PagamentoID;

					this.checkAfterSend(timeLoader, time);

				}, error => {
					this.preload(false);

					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				}
			);
		}
	}

	buildNormalFields() {
		const barcode = this.form.controls.barCode.value.split('.');
		const dividedDate = barcode[barcode.length - 1].substring(0, 4);

		if (dividedDate === '0000') {
			this.isDateInput = true;
		} else {
			this.form.controls.dueDate.clearValidators();
			this.form.controls.dueDate.updateValueAndValidity();
			this.form.controls.dueDateInput.setValidators(Validators.required);
			this.form.controls.dueDateInput.updateValueAndValidity();
			this.isDateInput = false;
			const startdate = '07.10.1997';
			const days = dividedDate;
			const new_date = moment(startdate, 'DD.MM.YYYY');
			new_date.add(days, 'days');
			const day = new_date.format('DD');
			const month = new_date.format('MM');
			const year = new_date.format('YYYY');
			this.form.controls.dueDateInput.setValue(
				day + '/' + month + '/' + year
			);
		}

		const value = barcode[barcode.length - 1].substring(4);
		const real = value.substring(0, value.length - 2);
		const cents = value.slice(-2);
		let formattedValue;
		if (value > 0) {
			formattedValue = real + '.' + cents;
		}
		if (formattedValue) {
			this.form.controls.value.setValue(parseFloat(formattedValue));
		}
		this.nominalValue = formattedValue;
		this.dataOfSecuritie = true;
		this.isSecuritie = false;
		this.updateHeight();
		this.form.controls.barCode.setErrors(null);
	}

	consultCip() {
		this.preload(true);

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		let dataForConsult;

		if (this.scheduleSpan) {
			dataForConsult = this.form.controls.scheduleDate.value;
		} else {
			dataForConsult = this.form.controls.paymentDate.value;
		}

		this.paymentService.consultPaymentCip(this.form.controls.barCode.value, dataForConsult).subscribe(
			data => {
				this.consultReturn = data;
				this.paymentData.nominalValue = this.consultReturn.nominalValue;
				this.paymentData.securitieRebateValue = this.consultReturn.securitieRebateValue;
				this.paymentData.taxValue = this.consultReturn.taxValue;
				this.paymentData.fineValue = this.consultReturn.fineValue;
				this.paymentData.chargesValue = this.consultReturn.chargesValue;
				this.paymentData.discountValue = this.consultReturn.discountValue;
				this.paymentData.assignorName = this.consultReturn.assignorName;
				this.paymentData.assignorCpfCnpj = this.consultReturn.assignorCpfCnpj;
				this.paymentData.payerAgency = this.consultReturn.payerAgency;
				this.paymentData.payerAccount = this.consultReturn.payerAccount;
				this.paymentData.payerName = this.consultReturn.payerName;
				this.paymentData.payerCpfCnpj = this.consultReturn.payerCpfCnpj;

				this.formInvalid.emit(this.consultReturn.paymentBlocked);

				if (this.securitieSend) {
					this.sendCipSecuritie(this.paymentData);
				} else {
					if (this.consultReturn.codeBarCip) {
						this.buildCipFields();
					} else {
						this.buildNormalFields();
					}
					this.clearPreload(time, timeLoader);
				}

				this.isDateChange = false;
			},
			error => {
				this.clearPreload(time, timeLoader);

				this.updateHeight();

				this.consultError = true;

				const mensagem = error.error.Mensagem ? error.error.Mensagem : 'Houve uma falha na conexão de internet. Por favor tente novamente.';

				switch (error.error.CodigoErro) {
					case (PaymentErrorType.BOLETO_JA_BAIXADO):
						this.openDialogError('Aviso!', mensagem);
						break;
					case PaymentErrorType.BOLETO_NAO_ENCONTRADO:
						this.openDialogError('O código de barras não foi localizado', mensagem);
						break;
					case (PaymentErrorType.CLIENTE_BENEFICIARIO_INAPTO):
						this.openDialogError('Ops, ocorreu um erro!', mensagem);
						break;
					case (PaymentErrorType.ERRO_NAO_MAPEADO):
						this.openDialogError('Ops, ocorreu um erro!', mensagem);
						break;
					default:
						this.openDialogError('Ops, ocorreu um erro!', mensagem);
					break;
				}

				TweenMax.delayedCall(.6, () => {
					AppEventDispatcher.dispatch(PaymentSecuritiesEventType.INIT, {});
				});

			}
		);
	}

	openDialogError(title: string, message: string) {
		if (this.dialogRef) {
			return;
		}

		this.dialogRef = this.dialog.open(ModalConfirmComponent, {
			width: '350px',
			data: {
				title: title,
				text: message,
        hideBackButton: true,
        confirmButton: 'Entendi',
			}
		});
	}

	sendCipSecuritie(paymentCip = null) {

		this.paymentData.barCode = this.form.controls.barCode.value.replace(/\D/g, '');
		this.paymentData.paymentType = 'Boleto';

		if (paymentCip) {
			if (this.minTypeValue) {
				this.paymentData.value = this.consultReturn.minValue;
			} else if (!this.parcialPayment) {
				this.paymentData.value = this.form.controls.value.value;
			} else {
				this.paymentData.value = this.consultReturn.value;
			}
		} else {
			if (this.minTypeValue) {
				this.paymentData.value = this.form.controls.minValue.value;
			} else {
				this.paymentData.value = this.form.controls.value.value;
			}
		}

		this.paymentData.discountValue = this.consultReturn.discountValue;

		if (this.isDateInput) {
			this.paymentData.dueDate = this.form.controls.dueDate.value;
		} else {
			const from = this.form.controls.dueDateInput.value.split('/');
			const f = new Date(from[2], from[1] - 1, from[0]);
			this.paymentData.dueDate = f;
		}

		if (this.form.controls.paymentDate.value === 'today') {
			this.paymentData.date = new Date();
			this.paymentData.dateType = 'today';
			this.paymentData.dateLabel = moment(new Date()).format('DD/MM/YYYY');
		} else {
			this.paymentData.dateType = 'schedule';
			this.paymentData.date = this.form.controls.scheduleDate.value;
			this.paymentData.dateLabel = moment(
				this.form.controls.scheduleDate.value
			).format('DD/MM/YYYY');
		}

		this.readySend();
	}

	sendNormalSecuritie() {
		this.paymentData.barCode = this.form.controls.barCode.value.replace(/\D/g, '');
		this.paymentData.paymentType = 'Boleto';
		this.paymentData.value = this.form.controls.value.value;

		if (this.isDateInput) {
			this.paymentData.dueDate = this.form.controls.dueDate.value;
		} else {
			const from = this.form.controls.dueDateInput.value.split('/');
			const f = new Date(from[2], from[1] - 1, from[0]);
			this.paymentData.dueDate = f;
		}

		if (this.form.controls.paymentDate.value === 'today') {
			this.paymentData.date = new Date();
			this.paymentData.dateType = 'today';
			this.paymentData.dateLabel = moment(new Date()).format('DD/MM/YYYY');
		} else {
			this.paymentData.dateType = 'schedule';
			this.paymentData.date = this.form.controls.scheduleDate.value;
			this.paymentData.dateLabel = moment(
				this.form.controls.scheduleDate.value
			).format('DD/MM/YYYY');
		}

		this.readySend();
	}

	readySend() {
		this.preload(true);

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		if (!this.barCodeError) {

			this.paymentService.sendPayment(this.paymentData).subscribe(data => {

					if (data.Retorno.DadosEntrada.DataAgendamento) {
						this.paymentData.dateLabel = data.Retorno.DadosEntrada.DataAgendamento;
					} else {
						this.paymentData.dateLabel = data.Retorno.DadosEntrada.DataEmissao;
					}

					this.paymentData.paymentId = data.Retorno.PagamentoID;

					this.paymentData.dueDateInput = data.Retorno.DadosEntrada.DataVencimento;

					this.checkAfterSend(timeLoader, time);

				}, error => {
					this.preload(false);

					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				}
			);
		}
	}

	send() {

		if (this.isSecuritie) {
			if (this.isDateChange) {
				this.securitieSend = true;
				this.consultCip();
			} else {
				this.sendCipSecuritie();
			}
		} else if (this.isAgreement) {
			this.sendAgreementSecuritie();
		} else {
			this.sendNormalSecuritie();
		}

	}

	validateMinMaxValue() {
		if (this.isSecuritie && !this.totalTypeValue && !this.parcialPayment && !this.anyValue) {
			if (this.form.controls.value.value < this.consultReturn.minValue) {
				this.biggerValueError = true;
				this.form.controls['value'].setErrors({'incorrect': true});
			} else if (this.form.controls.value.value > this.consultReturn.maxValue) {
				this.biggerValueError = true;
				this.form.controls['value'].setErrors({'incorrect': true});
			} else {
				this.biggerValueError = false;
				this.form.controls['value'].setErrors(null);
			}
		}
	}

	checkAfterSend(timeLoader, time, error = null) {
		if (error) {
			AppEventDispatcher.dispatch(PaymentSecuritiesEventType.ERROR, {
				step: PaymentSecuritiesEventType.STEPS.PAYMENT_DATA
			});
		}

		if (time > 5) {
			this.preload(false);
			if (error) {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error });
			} else {
				this.hide();
			}
		} else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false);
				if (error) {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error });
				} else {
					this.hide();
				}
			});
		}
		clearInterval(timeLoader);
	}

	minDate() {
		return new Date();
	}

	maxDate() {
		if (this.isSecuritie && this.consultReturn.securitieLimitDate !== undefined) {
			return moment(this.consultReturn.securitieLimitDate).add(1, 'days').format('YYYY-MM-DD');
		} else {
			return null;
		}
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {
			element: '[data-component="payment-securities"] .content',
			show: active,
			delay: delay
		});
	}

	clearPreload(time, timeLoader) {
		if (time > 5) {
			this.preload(false);
		} else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false, 3 - time);
			});
		}
		clearInterval(timeLoader);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-securities/payment-data/payment-data.component.ts